export default __webpack_public_path__ + "static/media/1684.180802e2.png";